import axios from "axios";
import { apiBaseURL, apiAuthHeader } from "./apiEnv";

export default (config, headers = null) => {
  return axios.create({
    baseURL: apiBaseURL,
    withCredentials: false,
    timeout: 30000,
    headers: Object.assign(
      {
        ...apiAuthHeader,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
        "Access-Control-Allow-Headers": "Origin, Content-Type, Authorization",
        "Content-Type": "application/json",
        store: config.store,
        isu: config.isu,
        platform: 1,
        version: import.meta.env.VITE_VERSION_PROJECT,
      },
      headers,
    ),
  });
};
